import {
  Box,
  HStack,
  Image,
  List,
  ListItem,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";

import VerifiedIcon from "assets/svg/verified.svg";
import PendingIcon from "assets/svg/verificationPending.svg";
import FailedIcon from "assets/svg/verificationFailed.svg";

import { useHistory } from "react-router-dom";

import Button from "components/Button/Button";

const VerificationCard = ({ disabled, level, status, to, isLoading }) => {
  const history = useHistory();

  console.log("verification", { disabled, level, status, to, isLoading });

  const styles = {
    listItem: {
      m: "10px 0",
    },
  };

  const statusIcon = (status) => {
    const iconMap = {
      approved: VerifiedIcon,
      pending: PendingIcon,
      denied: FailedIcon,
      expired: FailedIcon,
    };
    return iconMap[status];
  };

  const statusText = (status) => {
    const textMap = {
      approved: "verified",
      pending: "pending",
      denied: "failed",
      expired: "expired",
    };
    return textMap[status];
  };

  const levelLimit = (level) => {
    const limits = { 1: "$50/ day", 2: "$20,000/ day", 3: "Unlimited" };
    return limits[level];
  };

  const levelRequirements = (level) => {
    const requirements = {
      1: ["Email", "Phone Number"],
      2: ["ID Document"],
      3: ["Bank Information", "Address"],
    };
    return requirements[level];
  };
  return (
    <Box borderRadius="16px" bg="white">
      <Box p="26px 40px" borderBottom="1px solid #D9DBE9">
        <HStack justify="space-between">
          <Box>
            <Text color="#14142B" fontSize="1em" fontWeight="500">
              Level {level ?? 1}
            </Text>
            <Text mt="6px" color="#4E4B66" fontSize=".9em">
              Personal Information
            </Text>
          </Box>

          {status && <Image boxSize="2.2em" src={statusIcon(status)} />}
        </HStack>
      </Box>
      <Box p="26px 40px" borderBottom="1px solid #D9DBE9" color="#4E4B66">
        <Stack gridGap="4px">
          <Text fontWeight="400">Account Limit</Text>
          <Text m="0 !important" fontWeight="600">
            {levelLimit(level ?? 1)}
          </Text>
        </Stack>

        <List mt="30px">
          {levelRequirements(level ?? 1).map((requirement, i) => (
            <ListItem key={i} {...styles.listItem}>
              <HStack>
                {status === "approved" && <CheckCircleIcon color="#03A438" />}
                <Text textTransform="capitalize">{requirement}</Text>
              </HStack>
            </ListItem>
          ))}
        </List>
      </Box>
      <Box p="26px 40px" borderBottom="1px solid transparent" color="#4E4B66">
        <VStack>
          <Button
            isLoading={isLoading}
            onClick={() => history.push(to ?? "")}
            disabled={
              status
                ? status === "denied" || status === "expired"
                  ? false
                  : true
                : disabled
            }
          >
            {status
              ? status === "denied" || status === "expired"
                ? "verify"
                : statusText(status)
              : "verify"}
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default VerificationCard;
